import { isLocale, type Locale } from './i18n';

/**
 * Locale fields from a profile the server has already returned.
 *
 * `locale: null` means the account has no saved language. That is not the same
 * as a profile that is still in flight — callers pass `null` for the whole
 * snapshot until the request settles.
 */
export type LoadedProfileLocale = {
  locale?: string | null;
  localeSource?: string | null;
};

/**
 * Browser locale to store on a profile, or null when nothing should be written.
 *
 * Pass a null snapshot while the profile is loading. A loaded profile keeps a
 * locale it already has. An explicit choice is never replaced by the browser,
 * including when that choice's locale string has not arrived yet.
 */
export function browserLocaleToPersist(
  profile: LoadedProfileLocale | null | undefined,
  browserLocale: string | null | undefined
): Locale | null {
  if (profile == null) return null;
  if (profile.localeSource === 'explicit') return null;
  if (typeof profile.locale === 'string' && profile.locale.length > 0) return null;
  if (!browserLocale || !isLocale(browserLocale)) return null;
  return browserLocale;
}
